module.exports = __webpack_public_path__ + "img/DUCK LOGO-Yellow&Black--01.8fd1856a.png";